/**
 * TournamentConnector class.
 *
 * About classes  https://learn.javascript.ru/class-inheritance
 * @inheritDoc
 */

import SocketConnector from "./SocketConnector"

export default class TournamentConnector extends SocketConnector {

    constructor(socket)  {
        super(socket)
        this.verbose_name = "TournamentConnector:";
        this.controller_id = "tournament-rpc";
    
        this.STATUS_NONE               = 0;
        this.STATUS_ANNOUNCED          = 10;
        this.STATUS_OPEN               = 20;
        this.STATUS_IN_PLAY            = 30;
        this.STATUS_FINISHED           = 40;
        this.STATUS_CANCELED           = 50;

        this.PLAYERS_COUNT_MIN = 2;
        this.PLAYERS_COUNT_MAX = 64;

        this.my_uuid = null;        
        this.cb_state_changed = (data) => {this.__log("cb_tournament_changed", data); };
        
        this.__setupCallbacks();
    }

    __setupCallbacks() {
        
        this.socket.on("user_info", (data) => {
            this.my_uuid  = data.uuid;
        });

        this.socket.on("tournamentChanged", (data) => {
            this.__log("tournamentChanged", data);
            this.cb_state_changed(data);
        });
    };


    /**
     * join tournament
     * @param uuid uuid of tournament
     * @param cb function
     */
    async doJoin(uuid) {
        return this.__call("join", { uuid });
    };

    /**
     * view details
     * @param uuid uuid of tournament
     * @param cb function
     */
    async doView(uuid) {
        return this.__call("view", { uuid});
    };


    /**
     * Get list of tournaments
     *
     * @param search
     * @param search.status  int | "nearest" - open future| "actual" - open and in play| "active" - in play | "completed"
     * @param pagination
     * @param pagination.page   int
     * @param pagination.pageSize  int
     * @param cb function
     * 
     * 
     */
    
    async doGetListSearch(search, pagination) {
        return this.__call("list", {
            pagination: pagination,
            search: search
        });
    };


    /**
     * Get list of tournaments
     *
     * @param search
     * @param search.status  int
     * @param pagination
     * @param pagination.page   int
     * @param pagination.pageSize  int
     * @param cb function
     */
    async doGetListHistory(search, pagination) {
        return this.__call("history", {
            pagination: pagination,
            search: search
        });
    };


    /**
     * Get time till next tournament or tour
     *
     * @param cb function
     * returns
     *      "meta": {
     *         "timestamp": integer
     *      }
     *      "time" => {
     *        "tournament_start":integer
     *        "tour_end": integer
     *      }
     *
     */
    async doGetTimeLeft() {
        this.__call("get-time-left", {});
    };

    /**
     * callback when game list changed.
     * @param cb
     */
    setCallbackTournamentChanged(cb) {
        this.__log("setCallbackTournamentChanged");
        this.cb_state_changed = cb;
    };
}
